import { atom } from "jotai";

import { currentDurationOptionsAtom } from "../../stores";
import { courseIdSelectorAtom } from "../courseIdSelectorAtom/courseIdSelectorAtom";
import { DurationSelectorAtom } from "../durationSelectorAtom/durationSelectorAtom";
import { startSlotIdSelectorAtom } from "../startSlotIdSelectorAtom/startSlotIdSelectorAtom";

/**
 * Returns a string of slot IDs separated by commas
 *
 * This is a string rather than array so that we can return a stable value
 */
export const slotIdsToLockSelectorAtom = atom<string | null>((get) => {
  const currentDuration = get(DurationSelectorAtom);
  const currentCourseId = get(courseIdSelectorAtom);
  const currentDurationOptions = get(currentDurationOptionsAtom);
  const currentStartSlotId = get(startSlotIdSelectorAtom);

  if (currentDuration && currentCourseId && currentStartSlotId) {
    const durationOptionsForCurrentCourse = currentDurationOptions.find(
      (duration) => duration.courseId === currentCourseId
    );
    if (!durationOptionsForCurrentCourse) {
      return null;
    }

    const otherSlotIdsToLock =
      durationOptionsForCurrentCourse.endSlotOptions
        .filter((option) => option.durationMins <= currentDuration)
        .flatMap((option) => (option.slotId ? [option.slotId] : [])) ?? [];

    const slotIdsToLock = Array.from(
      new Set([currentStartSlotId, ...otherSlotIdsToLock])
    );

    return slotIdsToLock?.join(",") ?? null;
  }

  return null;
});
